/* ?karte=s oder ?karte=k an der Vorschau-URL (pro Tab gemerkt); ?karte=0 schaltet zurück */
(function () {
  'use strict';
  try {
    var m = location.search.match(/[?&]karte=([sk0])/);
    if (m) sessionStorage.setItem('ctKarte', m[1]);
    var v = sessionStorage.getItem('ctKarte');
    if (v === 's' || v === 'k') document.body.classList.add('ct-karte-' + v);
  } catch (e) {}
})();
